var render = function (_h,_vm) {var _c=_vm._c;return _c('span',{attrs:{"color":_vm.props.symbol.actualValue > _vm.props.symbol.startValue? 'green': _vm.props.symbol.actualValue < _vm.props.symbol.startValue? 'red' : ''}},[_vm._v(_vm._s(_vm._f("formatPrice")(_vm.props.symbol.actualValue)))])}
var staticRenderFns = []

export { render, staticRenderFns }